import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { gloversvilleConfig } from "./data";

export default function GloversvillePage() {
  return <CityPageTemplate config={gloversvilleConfig} />;
}